import { environment } from "../environments/environment";

export const BASE_API = environment.server_address;
